<script>
import { mapGetters } from 'vuex';
import SiteHeader from './components/SiteHeader';
import SiteBackground from './components/SiteBackground';
import SiteFooter from './components/SiteFooter';
import Overlay from './components/Overlay';
import CookieBanner from './components/CookieBanner';
import { setTimeout } from 'timers';

export default {
  name: 'app',
  metaInfo() {
    return {
      title: this.$t('global.title'),
      meta: [
        { vmid: 'description', name: 'description', content: this.$t('global.ogDescription') },
        { vmid: 'og:locale', property: 'og:locale', content: 'de_CH' },
        { vmid: 'og:type', property: 'og:type', content: 'article' },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.$t('global.ogTitel')
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.$t('global.ogDescription')
        },
        { vmid: 'og:url', property: 'og:url', content: this.$t('global.url') },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.$t('global.url') + '/og-image.jpg'
        },
        {
          vmid: 'og:site_name',
          property: 'og:site_name',
          content: this.$t('global.siteName')
        }
      ]
    };
  },
  components: {
    SiteHeader,
    SiteBackground,
    SiteFooter,
    Overlay,
    CookieBanner
  },
  data() {
    return {
      transitionName: null,
      show: true,
      bodyScrollTop: 0
    };
  },
  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    this.$store.dispatch('loadNavs');
  },
  computed: {
    ...mapGetters({
      overlayIsVisible: 'overlayIsVisible',
      footerIsVisible: 'getSiteFooterVisability',
      mainMenu: 'getMainNav'
    }),
    routerKey() {
      return this.$route.path.split('/')[1];
    }
  },
  watch: {
    $route(to, from) {
      const toPath = to.path.split('/')[1];
      const fromPath = from.path.split('/')[1];

      if (toPath !== fromPath) {
        const toPos = this.mainMenu.findIndex(item => item.slug === toPath);
        const fromPos = this.mainMenu.findIndex(item => item.slug === fromPath);
        this.transitionName = toPos < fromPos ? 'slide-right' : 'slide-left';
      } else this.transitionName = '';
    },
    overlayIsVisible(val) {
      if (val) {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        this.bodyScrollTop = scrollTop;
      } else {
        setTimeout(() => {
          window.scrollTo(0, this.bodyScrollTop);
        }, 0);
      }
    }
  }
};
</script>

<template>
  <div id="app" v-bind:class="{ 'app--no-scroll': overlayIsVisible }">
    <site-background />
    <site-header />
    <main class="app__main">
      <transition name="overlay">
        <overlay v-if="overlayIsVisible" />
      </transition>
      <transition v-bind:name="transitionName" mode="out-in">
        <router-view v-bind:key="routerKey" />
      </transition>
    </main>
    <site-footer v-if="footerIsVisible" />
    <cookie-banner />
  </div>
</template>

<style lang="scss">
@import './styles/static';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-primary;
}

.app--no-scroll {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
}

.app__background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  background: -108.8rem -32rem url(~@/assets/images/cloud-background.jpg) no-repeat;
  z-index: -1;

  @include breakpoint('md-down') {
    background-position: -112rem -32rem;
  }

  @include breakpoint('xs-down') {
    background-position: -120rem -32rem;
  }
}

.app__main {
  box-sizing: border-box;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
}

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
.browser-warning {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.8rem 1.6rem;
  background: $color-danger;
  color: $color-light;
  z-index: 20;

  a {
    color: $color-light;
  }
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: opacity 550ms, transform 550ms;
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-30%);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(30%);
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: opacity 550ms, transform 550ms;
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(30%);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-30%);
}

.overlay-leave-active {
  transition: opacity 200ms;
}

.overlay-leave-to {
  opacity: 0;
}
</style>
